import Alpine from 'alpinejs'

import widgetsPlugin from '@clickncode/widgets/plugin.mjs'
import { $u, plugin as uplandPlugin } from '@uplandjs/alpine'
import Deferred from 'p-defer'
import * as Sentry from '@sentry/browser'

window.Alpine = Alpine
window.$u = $u
window.Deferred = Deferred
Alpine.plugin(uplandPlugin)
Alpine.plugin(widgetsPlugin)
window.addEventListener('DOMContentLoaded', () => {
  Alpine.start()
})

window.Sentry = Sentry
let sentryEnvironment = 'dev'
if (window.location.host === 'gbof-staging.clickncode.com') {
  sentryEnvironment = 'staging'
} else if (window.location.host === 'app.gbof.ca') {
  sentryEnvironment = 'production'
}

if (sentryEnvironment !== 'dev') {
  window.Sentry.init({
    dsn: 'https://0cebbb1c1a6d41b6a75e767ca14d8b17@glitchtip.clickncode.com/2',
    environment: sentryEnvironment,
    tracesSampleRate: 0.01
  })
}
